import { z } from 'zod';
import { MediaKindSchema } from './enums/media.js';
/** IDs are 24-char hex ObjectId strings on the wire (05-api-specification.md § Conventions). */
export const IdSchema = z
    .string()
    .regex(/^[0-9a-f]{24}$/i, 'Must be a 24-character hex id')
    .meta({ id: 'Id', description: '24-character hex id' });
/** ISO 8601 UTC timestamp as sent in every response (`2026-10-12T10:15:00.000Z`). */
export const IsoDateTimeSchema = z.iso.datetime();
/** `createdAt` and `updatedAt` on every stored resource. Spread into resource schemas. */
export const TimestampsSchema = z.object({
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
});
/**
 * Response field that is always present: `null` when it has no value, never omitted
 * (05-api-specification.md § Field rules). A missing input key also serialises as `null`.
 */
export const nullable = (schema) => schema.nullable().default(null);
/** Bulk checkbox actions: `POST /…/bulk-delete` with `{ ids }` (max 100). */
export const BULK_IDS_MAX = 100;
export const BulkIdsSchema = z.strictObject({
    ids: z.array(IdSchema).min(1).max(BULK_IDS_MAX),
});
/** Bulk-delete response: `{ deleted, failed: [{ id, code }] }`. */
export const BulkResultSchema = z
    .object({
    deleted: z.number().int().min(0),
    failed: z.array(z.object({ id: IdSchema, code: z.string() })),
})
    .meta({ id: 'BulkResult' });
/** Resolved media object with absolute CDN URLs; never a storage key (ADR-0011). */
export const MediaRefSchema = z
    .object({
    id: IdSchema,
    kind: MediaKindSchema,
    thumb: nullable(z.url()),
    medium: nullable(z.url()),
    large: nullable(z.url()),
    poster: nullable(z.url()),
    hls: nullable(z.url()),
})
    .meta({ id: 'MediaRef' });
/** Storage is UTC; all display and calendar-day logic uses this zone (ADR-0013). */
export const DISPLAY_TIME_ZONE = 'Africa/Johannesburg';
//# sourceMappingURL=common.js.map